// src/components/VariantImageCell.tsx

import React, { useState } from 'react';
import { Button, Image } from 'antd';
import VariantImageModal from '../screens/protected/products/create-product/VariantImageModal';
import { ProductVariants } from '../types/CreateProductType';

interface Props {
  record: ProductVariants;
}

const VariantImageCell: React.FC<Props> = ({ record }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);

  const hasImage = Boolean(record.variant_image);
  const imageUrl = record.variant_image;

  return (
    <div style={{ textAlign: 'center' }}>
      {hasImage && (
        <>
          <Image
            width={80}
            height={80}
            src={imageUrl}
            alt="variant"
            style={{ objectFit: 'cover', borderRadius: 4 }}
          />
          <br />
        </>
      )}
      <Button type="link" onClick={openModal}>
        {hasImage ? 'Update Image' : 'Upload Image'}
      </Button>

      <VariantImageModal
        visible={modalVisible}
        onCancel={closeModal}
        record={record}
      />
    </div>
  );
};

export default VariantImageCell;
